import * as React from 'react';
import { v4 } from 'uuid';
import Styled from 'styled-components';

import { FormGroupRadio } from '../../Form';

interface IMultipleChoiceProps {
  multipleChoice?: boolean;
}

const AnswerContain = Styled.div`
  margin: 1.5em 0 0;
`;

const ConditionalContainer: React.FunctionComponent<IMultipleChoiceProps> = ({ multipleChoice, children }) => (
  !!multipleChoice
    ? <>{children}</>
    : <FormGroupRadio>{children}</FormGroupRadio>
);

export default class Answer extends React.PureComponent<React.HTMLAttributes<HTMLDivElement> & IMultipleChoiceProps> {
  private readonly _id: string = v4();

  public render () {
    // Multiple choice stuff should be refactored when we move Ver specific components out of frontend-component

    return (
      <AnswerContain {...this.props}>
        <ConditionalContainer multipleChoice={this.props.multipleChoice}>
          {React.Children.map(
            this.props.children,
            child =>
              React.isValidElement(child) ?
                // tslint:disable-next-line no-any
                React.cloneElement(child as any, {
                  groupName: (child.props as { groupName?: string }).groupName || this._id
                })
              : child
          )}
        </ConditionalContainer>
      </AnswerContain>
    );
  }
}
